module.exports = __webpack_public_path__ + "img/img0107.cf1a8b35.png";